export default [
    { key: "AF", en:"Afghanistan" , zh: "阿富汗"},
    { key: "AX", en:"Åland Islands" , zh: "奥兰"},
    { key: "AL", en:"Albania" , zh: "阿尔巴尼亚"},
    { key: "DZ", en:"Algeria" , zh: "阿尔及利亚"},
    { key: "AS", en:"American Samoa" , zh: "美属萨摩亚"},
    { key: "AD", en:"Andorra" , zh: "安道尔"},
    { key: "AO", en:"Angola" , zh: "安哥拉"},
    { key: "AI", en:"Anguilla" , zh: "安圭拉"},
    { key: "AQ", en:"Antarctica" , zh: "南极洲"},
    { key: "AG", en:"Antigua and Barbuda" , zh: "安提瓜和巴布达"},
    { key: "AR", en:"Argentina" , zh: "阿根廷"},
    { key: "AM", en:"Armenia" , zh: "亚美尼亚"},
    { key: "AW", en:"Aruba" , zh: "阿鲁巴"},
    { key: "AU", en:"Australia" , zh: "澳大利亚"},
    { key: "AT", en:"Austria" , zh: "奥地利"},
    { key: "AZ", en:"Azerbaijan" , zh: "阿塞拜疆"},
    { key: "BS", en:"Bahamas" , zh: "巴哈马"},
    { key: "BH", en:"Bahrain" , zh: "巴林"},
    { key: "BD", en:"Bangladesh" , zh: "孟加拉国"},
    { key: "BB", en:"Barbados" , zh: "巴巴多斯"},
    { key: "BY", en:"Belarus" , zh: "白俄罗斯"},
    { key: "BE", en:"Belgium" , zh: "比利时"},
    { key: "BZ", en:"Belize" , zh: "伯利兹"},
    { key: "BJ", en:"Benin" , zh: "贝宁"},
    { key: "BM", en:"Bermuda" , zh: "百慕大"},
    { key: "BT", en:"Bhutan" , zh: "不丹"},
    { key: "BO", en:"Bolivia (Plurinational State of)" , zh: "玻利维亚"},
    { key: "BQ", en:"Bonaire, Sint Eustatius and Saba" , zh: "荷兰加勒比区"},
    { key: "BA", en:"Bosnia and Herzegovina" , zh: "波黑"},
    { key: "BW", en:"Botswana" , zh: "博茨瓦纳"},
    { key: "BV", en:"Bouvet Island" , zh: "布韦岛"},
    { key: "BR", en:"Brazil" , zh: "巴西"},
    { key: "IO", en:"British Indian Ocean Territory" , zh: "英属印度洋领地"},
    { key: "BN", en:"Brunei Darussalam" , zh: "文莱"},
    { key: "BG", en:"Bulgaria" , zh: "保加利亚"},
    { key: "BF", en:"Burkina Faso" , zh: "布基纳法索"},
    { key: "BI", en:"Burundi" , zh: "布隆迪"},
    { key: "CV", en:"Cabo Verde" , zh: "佛得角"},
    { key: "KH", en:"Cambodia" , zh: "柬埔寨"},
    { key: "CM", en:"Cameroon" , zh: "喀麦隆"},
    { key: "CA", en:"Canada" , zh: "加拿大"},
    { key: "KY", en:"Cayman Islands" , zh: "开曼群岛"},
    { key: "CF", en:"Central African Republic" , zh: "中非"},
    { key: "TD", en:"Chad" , zh: "乍得"},
    { key: "CL", en:"Chile" , zh: "智利"},
    { key: "CN", en:"China" , zh: "中国"},
    { key: "CX", en:"Christmas Island" , zh: "圣诞岛"},
    { key: "CC", en:"Cocos (Keeling) Islands" , zh: "科科斯（基林）群岛"},
    { key: "CO", en:"Colombia" , zh: "哥伦比亚"},
    { key: "KM", en:"Comoros" , zh: "科摩罗"},
    { key: "CG", en:"Congo" , zh: "刚果共和国"},
    { key: "CD", en:"Congo (Democratic Republic of the)" , zh: "刚果民主共和国"},
    { key: "CK", en:"Cook Islands" , zh: "库克群岛"},
    { key: "CR", en:"Costa Rica" , zh: "哥斯达黎加"},
    { key: "CI", en:"Côte d'Ivoire" , zh: "科特迪瓦"},
    { key: "HR", en:"Croatia" , zh: "克罗地亚"},
    { key: "CU", en:"Cuba" , zh: "古巴"},
    { key: "CW", en:"Curaçao" , zh: "库拉索"},
    { key: "CY", en:"Cyprus" , zh: "塞浦路斯"},
    { key: "CZ", en:"Czechia" , zh: "捷克"},
    { key: "DK", en:"Denmark" , zh: "丹麦"},
    { key: "DJ", en:"Djibouti" , zh: "吉布提"},
    { key: "DM", en:"Dominica" , zh: "多米尼克"},
    { key: "DO", en:"Dominican Republic" , zh: "多米尼加"},
    { key: "EC", en:"Ecuador" , zh: "厄瓜多尔"},
    { key: "EG", en:"Egypt" , zh: "埃及"},
    { key: "SV", en:"El Salvador" , zh: "萨尔瓦多"},
    { key: "GQ", en:"Equatorial Guinea" , zh: "赤道几内亚"},
    { key: "ER", en:"Eritrea" , zh: "厄立特里亚"},
    { key: "EE", en:"Estonia" , zh: "爱沙尼亚"},
    { key: "SZ", en:"Eswatini" , zh: "斯威士兰"},
    { key: "ET", en:"Ethiopia" , zh: "埃塞俄比亚"},
    { key: "FK", en:"Falkland Islands (Malvinas)" , zh: "福克兰群岛"},
    { key: "FO", en:"Faroe Islands" , zh: "法罗群岛"},
    { key: "FJ", en:"Fiji" , zh: "斐济"},
    { key: "FI", en:"Finland" , zh: "芬兰"},
    { key: "FR", en:"France" , zh: "法国"},
    { key: "GF", en:"French Guiana" , zh: "法属圭亚那"},
    { key: "PF", en:"French Polynesia" , zh: "法属波利尼西亚"},
    { key: "TF", en:"French Southern Territories" , zh: "法属南部和南极领地"},
    { key: "GA", en:"Gabon" , zh: "加蓬"},
    { key: "GM", en:"Gambia" , zh: "冈比亚"},
    { key: "GE", en:"Georgia" , zh: "格鲁吉亚"},
    { key: "DE", en:"Germany" , zh: "德国"},
    { key: "GH", en:"Ghana" , zh: "加纳"},
    { key: "GI", en:"Gibraltar" , zh: "直布罗陀"},
    { key: "GR", en:"Greece" , zh: "希腊"},
    { key: "GL", en:"Greenland" , zh: "格陵兰"},
    { key: "GD", en:"Grenada" , zh: "格林纳达"},
    { key: "GP", en:"Guadeloupe" , zh: "瓜德罗普"},
    { key: "GU", en:"Guam" , zh: "关岛"},
    { key: "GT", en:"Guatemala" , zh: "危地马拉"},
    { key: "GG", en:"Guernsey" , zh: "根西"},
    { key: "GN", en:"Guinea" , zh: "几内亚"},
    { key: "GW", en:"Guinea-Bissau" , zh: "几内亚比绍"},
    { key: "GY", en:"Guyana" , zh: "圭亚那"},
    { key: "HT", en:"Haiti" , zh: "海地"},
    { key: "HM", en:"Heard Island and McDonald Islands" , zh: "赫德岛和麦克唐纳群岛"},
    { key: "VA", en:"Holy See" , zh: "梵蒂冈"},
    { key: "HN", en:"Honduras" , zh: "洪都拉斯"},
    { key: "HK", en:"Hong Kong" , zh: "中国香港"},
    { key: "HU", en:"Hungary" , zh: "匈牙利"},
    { key: "IS", en:"Iceland" , zh: "冰岛"},
    { key: "IN", en:"India" , zh: "印度"},
    { key: "ID", en:"Indonesia" , zh: "印度尼西亚"},
    { key: "IR", en:"Iran (Islamic Republic of)" , zh: "伊朗"},
    { key: "IQ", en:"Iraq" , zh: "伊拉克"},
    { key: "IE", en:"Ireland" , zh: "爱尔兰"},
    { key: "IM", en:"Isle of Man" , zh: "马恩岛"},
    { key: "IL", en:"Israel" , zh: "以色列"},
    { key: "IT", en:"Italy" , zh: "意大利"},
    { key: "JM", en:"Jamaica" , zh: "牙买加"},
    { key: "JP", en:"Japan" , zh: "日本"},
    { key: "JE", en:"Jersey" , zh: "泽西"},
    { key: "JO", en:"Jordan" , zh: "约旦"},
    { key: "KZ", en:"Kazakhstan" , zh: "哈萨克斯坦"},
    { key: "KE", en:"Kenya" , zh: "肯尼亚"},
    { key: "KI", en:"Kiribati" , zh: "基里巴斯"},
    { key: "KP", en:"Korea (Democratic People's Republic of)" , zh: "朝鲜"},
    { key: "KR", en:"Korea (Republic of)" , zh: "韩国"},
    { key: "KW", en:"Kuwait" , zh: "科威特"},
    { key: "KG", en:"Kyrgyzstan" , zh: "吉尔吉斯斯坦"},
    { key: "LA", en:"Lao People's Democratic Republic" , zh: "老挝"},
    { key: "LV", en:"Latvia" , zh: "拉脱维亚"},
    { key: "LB", en:"Lebanon" , zh: "黎巴嫩"},
    { key: "LS", en:"Lesotho" , zh: "莱索托"},
    { key: "LR", en:"Liberia" , zh: "利比里亚"},
    { key: "LY", en:"Libya" , zh: "利比亚"},
    { key: "LI", en:"Liechtenstein" , zh: "列支敦士登"},
    { key: "LT", en:"Lithuania" , zh: "立陶宛"},
    { key: "LU", en:"Luxembourg" , zh: "卢森堡"},
    { key: "MO", en:"Macao" , zh: "澳门"},
    { key: "MG", en:"Madagascar" , zh: "马达加斯加"},
    { key: "MW", en:"Malawi" , zh: "马拉维"},
    { key: "MY", en:"Malaysia" , zh: "马来西亚"},
    { key: "MV", en:"Maldives" , zh: "马尔代夫"},
    { key: "ML", en:"Mali" , zh: "马里"},
    { key: "MT", en:"Malta" , zh: "马耳他"},
    { key: "MH", en:"Marshall Islands" , zh: "马绍尔群岛"},
    { key: "MQ", en:"Martinique" , zh: "马提尼克"},
    { key: "MR", en:"Mauritania" , zh: "毛里塔尼亚"},
    { key: "MU", en:"Mauritius" , zh: "毛里求斯"},
    { key: "YT", en:"Mayotte" , zh: "马约特"},
    { key: "MX", en:"Mexico" , zh: "墨西哥"},
    { key: "FM", en:"Micronesia (Federated States of)" , zh: "密克罗尼西亚联邦"},
    { key: "MD", en:"Moldova (Republic of)" , zh: "摩尔多瓦"},
    { key: "MC", en:"Monaco" , zh: "摩纳哥"},
    { key: "MN", en:"Mongolia" , zh: "蒙古"},
    { key: "ME", en:"Montenegro" , zh: "黑山"},
    { key: "MS", en:"Montserrat" , zh: "蒙特塞拉特"},
    { key: "MA", en:"Morocco" , zh: "摩洛哥"},
    { key: "MZ", en:"Mozambique" , zh: "莫桑比克"},
    { key: "MM", en:"Myanmar" , zh: "缅甸"},
    { key: "NA", en:"Namibia" , zh: "纳米比亚"},
    { key: "NR", en:"Nauru" , zh: "瑙鲁"},
    { key: "NP", en:"Nepal" , zh: "尼泊尔"},
    { key: "NL", en:"Netherlands" , zh: "荷兰"},
    { key: "NC", en:"New Caledonia" , zh: "新喀里多尼亚"},
    { key: "NZ", en:"New Zealand" , zh: "新西兰"},
    { key: "NI", en:"Nicaragua" , zh: "尼加拉瓜"},
    { key: "NE", en:"Niger" , zh: "尼日尔"},
    { key: "NG", en:"Nigeria" , zh: "尼日利亚"},
    { key: "NU", en:"Niue" , zh: "纽埃"},
    { key: "NF", en:"Norfolk Island" , zh: "诺福克岛"},
    { key: "MK", en:"North Macedonia" , zh: "北马其顿"},
    { key: "MP", en:"Northern Mariana Islands" , zh: "北马里亚纳群岛"},
    { key: "NO", en:"Norway" , zh: "挪威"},
    { key: "OM", en:"Oman" , zh: "阿曼"},
    { key: "PK", en:"Pakistan" , zh: "巴基斯坦"},
    { key: "PW", en:"Palau" , zh: "帕劳"},
    { key: "PS", en:"Palestine, State of" , zh: "巴勒斯坦"},
    { key: "PA", en:"Panama" , zh: "巴拿马"},
    { key: "PG", en:"Papua New Guinea" , zh: "巴布亚新几内亚"},
    { key: "PY", en:"Paraguay" , zh: "巴拉圭"},
    { key: "PE", en:"Peru" , zh: "秘鲁"},
    { key: "PH", en:"Philippines" , zh: "菲律宾"},
    { key: "PN", en:"Pitcairn" , zh: "皮特凯恩群岛"},
    { key: "PL", en:"Poland" , zh: "波兰"},
    { key: "PT", en:"Portugal" , zh: "葡萄牙"},
    { key: "PR", en:"Puerto Rico" , zh: "波多黎各"},
    { key: "QA", en:"Qatar" , zh: "卡塔尔"},
    { key: "RE", en:"Réunion" , zh: "留尼汪"},
    { key: "RO", en:"Romania" , zh: "罗马尼亚"},
    { key: "RU", en:"Russian Federation" , zh: "俄罗斯"},
    { key: "RW", en:"Rwanda" , zh: "卢旺达"},
    { key: "BL", en:"Saint Barthélemy" , zh: "圣巴泰勒米"},
    { key: "SH", en:"Saint Helena, Ascension and Tristan da Cunha" , zh: "圣赫勒拿、阿森松和特里斯坦-达库尼亚"},
    { key: "KN", en:"Saint Kitts and Nevis" , zh: "圣基茨和尼维斯"},
    { key: "LC", en:"Saint Lucia" , zh: "圣卢西亚"},
    { key: "MF", en:"Saint Martin (French part)" , zh: "法属圣马丁"},
    { key: "PM", en:"Saint Pierre and Miquelon" , zh: "圣皮埃尔和密克隆"},
    { key: "VC", en:"Saint Vincent and the Grenadines" , zh: "圣文森特和格林纳丁斯"},
    { key: "WS", en:"Samoa" , zh: "萨摩亚"},
    { key: "SM", en:"San Marino" , zh: "圣马力诺"},
    { key: "ST", en:"Sao Tome and Principe" , zh: "圣多美和普林西比"},
    { key: "SA", en:"Saudi Arabia" , zh: "沙特阿拉伯"},
    { key: "SN", en:"Senegal" , zh: "塞内加尔"},
    { key: "RS", en:"Serbia" , zh: "塞尔维亚"},
    { key: "SC", en:"Seychelles" , zh: "塞舌尔"},
    { key: "SL", en:"Sierra Leone" , zh: "塞拉利昂"},
    { key: "SG", en:"Singapore" , zh: "新加坡"},
    { key: "SX", en:"Sint Maarten (Dutch part)" , zh: "荷属圣马丁"},
    { key: "SK", en:"Slovakia" , zh: "斯洛伐克"},
    { key: "SI", en:"Slovenia" , zh: "斯洛文尼亚"},
    { key: "SB", en:"Solomon Islands" , zh: "所罗门群岛"},
    { key: "SO", en:"Somalia" , zh: "索马里"},
    { key: "ZA", en:"South Africa" , zh: "南非"},
    { key: "GS", en:"South Georgia and the South Sandwich Islands" , zh: "南乔治亚和南桑威奇群岛"},
    { key: "SS", en:"South Sudan" , zh: "南苏丹"},
    { key: "ES", en:"Spain" , zh: "西班牙"},
    { key: "LK", en:"Sri Lanka" , zh: "斯里兰卡"},
    { key: "SD", en:"Sudan" , zh: "苏丹"},
    { key: "SR", en:"Suriname" , zh: "苏里南"},
    { key: "SJ", en:"Svalbard and Jan Mayen" , zh: "斯瓦尔巴和扬马延"},
    { key: "SE", en:"Sweden" , zh: "瑞典"},
    { key: "CH", en:"Switzerland" , zh: "瑞士"},
    { key: "SY", en:"Syrian Arab Republic" , zh: "叙利亚"},
    { key: "TW", en:"Taiwan, Province of China[note 1]" , zh: "中国台湾省"},
    { key: "TJ", en:"Tajikistan" , zh: "塔吉克斯坦"},
    { key: "TZ", en:"Tanzania, United Republic of" , zh: "坦桑尼亚"},
    { key: "TH", en:"Thailand" , zh: "泰国"},
    { key: "TL", en:"Timor-Leste" , zh: "东帝汶"},
    { key: "TG", en:"Togo" , zh: "多哥"},
    { key: "TK", en:"Tokelau" , zh: "托克劳"},
    { key: "TO", en:"Tonga" , zh: "汤加"},
    { key: "TT", en:"Trinidad and Tobago" , zh: "特立尼达和多巴哥"},
    { key: "TN", en:"Tunisia" , zh: "突尼斯"},
    { key: "TR", en:"Türkiye" , zh: "土耳其"},
    { key: "TM", en:"Turkmenistan" , zh: "土库曼斯坦"},
    { key: "TC", en:"Turks and Caicos Islands" , zh: "特克斯和凯科斯群岛"},
    { key: "TV", en:"Tuvalu" , zh: "图瓦卢"},
    { key: "UG", en:"Uganda" , zh: "乌干达"},
    { key: "UA", en:"Ukraine" , zh: "乌克兰"},
    { key: "AE", en:"United Arab Emirates" , zh: "阿联酋"},
    { key: "GB", en:"United Kingdom of Great Britain and Northern Ireland" , zh: "英国"},
    { key: "US", en:"United States of America" , zh: "美国"},
    { key: "UM", en:"United States Minor Outlying Islands" , zh: "美国本土外小岛屿"},
    { key: "UY", en:"Uruguay" , zh: "乌拉圭"},
    { key: "UZ", en:"Uzbekistan" , zh: "乌兹别克斯坦"},
    { key: "VU", en:"Vanuatu" , zh: "瓦努阿图"},
    { key: "VE", en:"Venezuela (Bolivarian Republic of)" , zh: "委内瑞拉"},
    { key: "VN", en:"Viet Nam" , zh: "越南"},
    { key: "VG", en:"Virgin Islands (British)" , zh: "英属维尔京群岛"},
    { key: "VI", en:"Virgin Islands (U.S.)" , zh: "美属维尔京群岛"},
    { key: "WF", en:"Wallis and Futuna" , zh: "瓦利斯和富图纳"},
    { key: "EH", en:"Western Sahara" , zh: "西撒哈拉"},
    { key: "YE", en:"Yemen" , zh: "也门"},
    { key: "ZM", en:"Zambia" , zh: "赞比亚"},
    { key: "ZW", en:"Zimbabwe" , zh: "津巴布韦"},
    { key: "EU", en:"European Union" , zh: "欧盟"},
]